import { Serializable } from '../interfaces';

enum PerfilConsumo {
  BASICO = 'BASICO',
  COCHE_ELECTRICO = 'COCHE_ELECTRICO',
  CALEFACCION_ELECTRICA = 'CALEFACCION_ELECTRICA',
  CALENTADOR_AGUA_ELECTRICO = 'CALENTADOR_AGUA_ELECTRICO',
  CALENTADOR = 'CALENTADOR',
  COCHE = 'COCHE',
  CALEFACCION = 'CALEFACCION',
  INDUSTRIAL = 'INDUSTRIAL',
}

export interface OnboardingPerfilDeConsumoAPI {
  id: number;
  perfil_consumidor: PerfilConsumo;
  curva_consumo: boolean;
  fecha_actualizacion: string;
}

export default class OnboardingPerfilDeConsumo implements Serializable<OnboardingPerfilDeConsumo> {
  id: number;

  perfil_consumidor: PerfilConsumo;

  curva_consumo: boolean;

  fecha_actualizacion: string;

  deserialize(input: OnboardingPerfilDeConsumoAPI): OnboardingPerfilDeConsumo {
    if (!input) {
      return this;
    }

    this.id = input.id;
    this.perfil_consumidor = input.perfil_consumidor;
    this.curva_consumo = input.curva_consumo;
    this.fecha_actualizacion = input.fecha_actualizacion;

    return this;
  }

  deserializeArray(inputArray: Array<OnboardingPerfilDeConsumoAPI>): Array<OnboardingPerfilDeConsumo> {
    return inputArray.map((input) => new OnboardingPerfilDeConsumo().deserialize(input));
  }

  setAttr<T>(key: string, value: T): void {
    Object.assign(this, { [key]: value });
  }
}
